import {
   HealthcareProviderAppointmentConfirmationPatientNotificationConfigurationQuery,
   HealthcareProviderNotificationConfiguration,
} from '@dreryk/egabinet-phone-notification-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';

type PatientPhoneNotificationAppointmentConfirmationToggleLoaderResult = {
   notificationEnabled: boolean;
   messages: string[];
   refetch: VoidFunction;
};

type PatientPhoneNotificationAppointmentConfirmationToggleLoaderProps = {
   readonly children: (result: PatientPhoneNotificationAppointmentConfirmationToggleLoaderResult) => JSX.Element;
};

export const PatientPhoneNotificationAppointmentConfirmationToggleLoader = (
   props: PatientPhoneNotificationAppointmentConfirmationToggleLoaderProps
): JSX.Element | null => {
   const {
      data: healthcareProviderNotificationConfiguration,
      loading: healthcareProviderNotificationConfigurationLoading,
      error: healthcareProviderNotificationConfigurationError,
      refetch,
   } = useCqrsGet<HealthcareProviderNotificationConfiguration>(() => {
      return new HealthcareProviderAppointmentConfirmationPatientNotificationConfigurationQuery();
   });

   if (
      healthcareProviderNotificationConfigurationLoading ||
      healthcareProviderNotificationConfigurationError ||
      !healthcareProviderNotificationConfiguration
   ) {
      return null;
   }

   return props.children({
      notificationEnabled: healthcareProviderNotificationConfiguration.enabled,
      messages: healthcareProviderNotificationConfiguration.messages,
      refetch: refetch,
   });
};
